import React, { ChangeEvent, ReactElement, useEffect, useRef, useState } from 'react'
import Container from '../containerComp/Container'
import { CreateWarningPropsTypes } from './CreateWarningTypes'
import { earlyWarningTypes } from './FixedDataSet'
import HRWWarning from './HRWWarning'
import FLWWarning from './FLWWarning'
import LIGWarning from './LIGWarning'
import LSWWarning from './LSWWarning'
import MWAWarning from './MWAWarning'
import HWNWarning from './HWNWarning'
import NTWWarning from './NTWWarning'
import ASWWarning from './ASWWarning'
import { APICallGetWarningTypeRequest, APIWarningTypeResponseType } from '../../services/APIEarlyWarningService'
import { useLocation, useNavigate } from 'react-router-dom'
import TWWarning from './TWWarning'
import CUSWarning from './CUSWarning'
import GUSWarning from './GUSWarning'
import ToggleSwitch from './ToggleSwitch'
import { APITemplateResponse } from '../../services/APITemplateService'
import EWTemplate from './EWTemplate'
import { useUserData } from '../../context/UserDataContext'

export type UserData = {
    accessprivileges: string;
    address: string;
    country: string;
    department: string;
    email: string;
    firstname: string;
    lastname: string;
    mobilenumber: string;
    nic: string;
    organization: string;
    policies: string;
    role: string;
    themecolorbconex: string;
    thememodebconex: string;
    thememodeeaglei: string;
    username: string;
}

export type PoliceTypes = {
    simple: boolean, 
    advanced: boolean, 
    defaultSimple: boolean, 
    defaultAdvanced: boolean
}

const CreateWarning = (props: CreateWarningPropsTypes) => {

    const location = useLocation();
    const paramsData = new URLSearchParams(location.search);
    const data = JSON.parse(paramsData.get("data") || "{}") as APIWarningTypeResponseType;

    const { username, hasPolicy, loading } = useUserData()

    // Loading screen
    const [isLoading, setIsLoading] = useState<boolean>(true)

    const navigate = useNavigate();

    const BASE_URL = process.env.REACT_APP_BASE_URL;

    const [selectedType, setSelectedType] = useState<APIWarningTypeResponseType>()
    const [selectedPage, setSelectedPage] = useState<"SELECT" | "FORM">('SELECT')

    const [warningTypes, setWarningTypes] = useState<APIWarningTypeResponseType[]>([]);

    const userIdRef = useRef<string>();

    const [selectedTemplate, setSelectedTemplate] = useState<APITemplateResponse | null>(null)

    const [userPolices, setUserPolices] = useState<PoliceTypes>({ simple: false, advanced: false, defaultSimple: false, defaultAdvanced: false})

    //useEffect(() => {console.log("PRINT -> ", userPolices)}, [userPolices])

    useEffect(() => {
        const fetchInitialData = async () => {
            try {
                // const savedUser = sessionStorage.getItem("user");
                // if (!savedUser) {
                //     throw new Error("No user in sessionStorage");
                // }

                // const parsedUser = JSON.parse(savedUser);
                // const userId = parsedUser.userId;
                // userIdRef.current = userId

                const result = await APICallGetWarningTypeRequest(username);
                setWarningTypes(result); // set response to state if needed
                //console.log(">>>>>>>>> result:", result)
            } catch (error) {
                console.error("Initialization error:", error);
            } finally {
                setIsLoading(false);
            }
        }

        fetchInitialData();
    }, [loading])

    const handleEWTypeClick = (ewType: APIWarningTypeResponseType) => {
        setSelectedType(ewType)
        setSelectedPage("FORM")

    }

    // Handle type select next button click
    /* const handleTypeSelectNextButton = (): void => {
        setSelectedPage("FORM")
    } */

    const findIcon = (wType: string): ReactElement<any, any> | null => {
        const match = earlyWarningTypes.find(item => item.wType === wType);
        return match?.icon ?? null;
    }

    const [pendingCount, setPendingCount] = useState<number>(0)
    const [incidentCount, setIncidentCount] = useState<number>(0)

    const getPendingWarningCount = async () => {
        const token = localStorage.getItem("access_token");
        fetch(`${BASE_URL}/ew/api/v1/getPendingCount`, {
            method: "GET",
            headers: {
                Authorization: `Bearer ${token}`,
                "Content-Type": "application/json",
            },
        })
        .then((res) => res.json())
        .then((data) => {
            const response = data as number
            //console.log(">>>>>>> data: ", data)
            setPendingCount(response)
        })
        .catch((err) => console.error("Error fetching roles:", err));
    }

    useEffect(() => {
        const params = new URLSearchParams()
        params.append("arealist", "LK1333")
        params.append("arealist", "LK1312")

        fetch (`${BASE_URL}/hz/api/v1/getHzmByLocationTwoWeek?${params.toString()}`, {
            method: 'GET'
        })
        .then(response => response.json())
        .then(data => {
            const response = data as []
            //console.log("incident data: ", response)
            setIncidentCount(response.length)
        })
        .catch(error => console.log(error))

        getPendingWarningCount()
    }, [])

    // useEffect(() => {
    //     const userDataString = sessionStorage.getItem("userdetails")
    //     if (userDataString) {
    //         const userData: UserData = JSON.parse(userDataString)
    //         const policiesList: string[] = userData.policies.split(',').map(policy => policy.trim())
    
    //         setUserPolices({
    //             simple: policiesList.includes("Simple Early Warning Trigger"),
    //             advanced: policiesList.includes("Advance Early Warning Trigger"),
    //             defaultSimple: policiesList.includes("Both Early Warning Trigger - Simple"),
    //             defaultAdvanced: policiesList.includes("Both Early Warning Trigger - Advance"),
    //         })
    //     } else {
    //         setUserPolices({ simple: false, advanced: false, defaultSimple: false, defaultAdvanced: false })
    //     }
    // }, [])

    // useEffect(() => {
    //     setUserPolices({
    //         simple: hasPolicy("SIMPLE_EARLY_WARNING_TRIGGER"),
    //         advanced: hasPolicy("ADVANCED_EARLY_WARNING_TRIGGER"),
    //         defaultSimple: hasPolicy("BOTH_EARLY_WARNING_TRIGGER_SIMPLE"),
    //         defaultAdvanced: hasPolicy("BOTH_EARLY_WARNING_TRIGGER_ADVANCED"),
    //     })
    // }, [])

    const [toggle, setToggle] = useState<boolean>(false)
    useEffect(() => {
        if (userPolices)
        {
            if (hasPolicy("SIMPLE_EARLY_WARNING_TRIGGER") && !hasPolicy("ADVANCED_EARLY_WARNING_TRIGGER")) 
            {
                setToggle(false)
            }
            else if (!hasPolicy("SIMPLE_EARLY_WARNING_TRIGGER") && hasPolicy("ADVANCED_EARLY_WARNING_TRIGGER"))
            {
                setToggle(true)
            }

            if (hasPolicy("BOTH_EARLY_WARNING_TRIGGER_ADVANCED") && !hasPolicy("BOTH_EARLY_WARNING_TRIGGER_SIMPLE"))
            {
                setToggle(true)
            }
            else if (!hasPolicy("BOTH_EARLY_WARNING_TRIGGER_ADVANCED") && hasPolicy("BOTH_EARLY_WARNING_TRIGGER_SIMPLE"))
            {
                setToggle(false)
            }
        }
    }, [hasPolicy])

    useEffect(() => {
        const isEmpty = Object.keys(data).length === 0;
        if (isEmpty) {
        } else {
            setSelectedType(data)
            setSelectedPage("FORM")
        }
        
    }, [])

    return (
        <Container isLoading={isLoading}>
            <div className='create-warning'>
                <div className='title'>
                    <span>Generate Early Warnings</span>
                </div>
                {/* Type selector */}
                {selectedPage === 'SELECT' && (
                    <>
                        {/* <div className='dashboard-card-wrapper'>
                            <div className='title'>
                                <span>Status</span>
                            </div>
                            <div className='dashboard-card-holder'>
                                <div className='type-selector-wrapper-container'>
                                    <div className='ew-item' style={{height: '5rem'}} onClick={() => navigate('/early_warning/early_warning_messages')}>
                                        <span style={{fontSize: `2rem`, fontWeight: '700'}}>{pendingCount}</span>
                                        <span>Pending early warnings</span>
                                    </div>
                                </div>
                                <div className='type-selector-wrapper-container'>
                                    <div className='ew-item' style={{height: '5rem'}} onClick={() => navigate('/incidents')}>
                                        <span style={{fontSize: `2rem`, fontWeight: '700'}}>{incidentCount}</span>
                                        <span>Incidents (Last two weeks)</span>
                                    </div>
                                </div>
                            </div>
                            
                        </div> */}
                        <div className='type-selector-wrapper'>
                            <div className='title'>
                                {/* {!selectedTemplate ? (<span>select warning {toggle ? 'type' : 'template'}</span>) : (<span>setup {selectedTemplate.name} (Template)</span>)} */}
                                <span>Generate Early Warning</span>
                                {/* {!selectedTemplate && (
                                    userPolices.simple && userPolices.advanced && (
                                        <div className='switch-wrapper'>
                                            <ToggleSwitch switchState={toggle} setSwitchState={setToggle} width={2} leftLabel='simple' rightLabel='advanced' backgroundColor='var(--color-data-wrapper-bg)' switchColor='var(--color-accent)'/>
                                        </div>
                                    )
                                )} */}
                                
                            </div>
                            {!selectedTemplate && (
                                (hasPolicy("SIMPLE_EARLY_WARNING_TRIGGER") && hasPolicy("ADVANCED_EARLY_WARNING_TRIGGER")) && (
                                    <div className="tab-wrapper">
                                        <div className="tab-button" style={{borderRadius: '0 0.5rem 0 0', backgroundColor: !toggle ? "var(--color-email-side-menu-bg)" : "transparent", borderWidth: toggle ? "0 0 0.2rem 0" : "0.2rem"}} onClick={(e) => setToggle(false)}>
                                            <span>Template-Based</span>
                                        </div>
                                        <div className="tab-button" style={{borderRadius: '0.5rem 0 0 0', borderWidth: !toggle ? "0 0 0.2rem 0" : "0.2rem", backgroundColor: toggle ? "var(--color-email-side-menu-bg)" : "transparent",}} onClick={(e) => setToggle(true)}>
                                            <span>Customized</span>
                                        </div>
                                    </div>
                                )
                            )}
                            
                            {toggle && (
                                <>
                                    {warningTypes.length > 0 ? (
                                        <div className='type-selector-wrapper-container'>
                                            {warningTypes.map((ewType, index) => (
                                                <div key={index} className='ew-item' onClick={(e) => handleEWTypeClick(ewType)} style={{backgroundColor: selectedType?.warningId === ewType.warningId ? 'var(--color-card-select-bg)' : 'var(--color-card-bg)'}}>
                                                    {findIcon(ewType.hazardType)}
                                                    <span>{ewType.warningName}</span>
                                                </div>
                                            ))}
                                        </div>
                                    ) : (
                                        <div className='type-selector-wrapper-container-empty'>
                                            <span>No any warning types available for you</span>
                                        </div>
                                    )}
                                </>
                                
                            )}
                            {!toggle && (
                                hasPolicy('SIMPLE_EARLY_WARNING_TRIGGER') && (
                                    <EWTemplate selectedTemplate={selectedTemplate} setSelectedTemplate={setSelectedTemplate} setToggle={setToggle} isButtonActive={warningTypes.length > 0 ? true : false}/>
                                )
                            )}
                            
                        </div>
                        {/* <div className={`button-wrapper`} style={{gridArea: 'button'}}>
                            <div className={`left-side`}></div>
                            <div className={`right-side`}>
                                {selectedType && (
                                    <button className={`button-normal`} onClick={(e) => handleTypeSelectNextButton()}>next</button>
                                )}
                            </div>
                        </div> */}
                    </>
                )}
               
                {selectedPage === "FORM" && (
                    <div>
                        {selectedType?.hazardType === "HRW" && (
                            <HRWWarning ewType={selectedType} username={userIdRef.current ? userIdRef.current : ''}/>
                        )}
                        {selectedType?.hazardType === "FLW" && (
                            <FLWWarning ewType={selectedType} username={userIdRef.current ? userIdRef.current : ''}/>
                        )}
                        {selectedType?.hazardType === "LIG" && (
                            <LIGWarning ewType={selectedType} username={userIdRef.current ? userIdRef.current : ''} />
                        )}
                        {selectedType?.hazardType === "LSW" && (
                            <LSWWarning ewType={selectedType} username={userIdRef.current ? userIdRef.current : ''} />
                        )}
                        {selectedType?.hazardType === "MWA" && (
                            <MWAWarning ewType={selectedType} username={userIdRef.current ? userIdRef.current : ''} />
                        )}
                        {selectedType?.hazardType === "HWN" && (
                            <HWNWarning ewType={selectedType} username={userIdRef.current ? userIdRef.current : ''} />
                        )}
                        {selectedType?.hazardType === "NTW" && (
                            <NTWWarning ewType={selectedType} username={userIdRef.current ? userIdRef.current : ''} />
                        )}
                        {selectedType?.hazardType === "ASW" && (
                            <ASWWarning ewType={selectedType} username={userIdRef.current ? userIdRef.current : ''} />
                        )}
                        {selectedType?.hazardType === "TW" && (
                            <TWWarning ewType={selectedType} username={userIdRef.current ? userIdRef.current : ''} />
                        )}
                        {selectedType?.hazardType === "CUS" && (
                            <CUSWarning ewType={selectedType} username={userIdRef.current ? userIdRef.current : ''} />
                        )}
                        {selectedType?.hazardType === "GUS" && (
                            <GUSWarning ewType={selectedType} username={userIdRef.current ? userIdRef.current : ''} />
                        )}
                    </div>
                )}
            </div>
        </Container>
    )
}

export default CreateWarning